import { Provider } from 'react-redux';
import MyAccountPage from './MyAccountPage';
import store from './store';

const MyAccountContainer = () => (
  <Provider store={store}>
    <MyAccountPage />
  </Provider>
);

export default MyAccountContainer;
